<template>
	<WebViewLayout class="pt-200">
		<DisclosuresFull route-name="webview-legal-disclosure" />
	</WebViewLayout>
</template>

<script setup lang="ts">
import DisclosuresFull from '@components/legal/disclosures-full.vue';
import WebViewLayout from '@views/webview/web-view-layout.vue';
</script>
